import { defineComponent } from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    isSos: {
      type: Boolean,
      default: false,
    },
    initOpen: {
      type: Boolean,
      default: false,
    },
    question: {
      type: String,
      default: null,
    },
    answer: {
      type: String,
      default: null,
    },
  },
  data(props) {
    return {
      opened: props.initOpen,
    };
  },
  methods: {
    toggle() {
      this.opened = !this.opened;
    }
  },
  template: '#t-accordion-section',
});
